__turbopack_context__.v({
  "Remove": "avatar-uploader-module__O6QoJa__Remove",
  "UploadButton": "avatar-uploader-module__O6QoJa__UploadButton",
  "UploadText": "avatar-uploader-module__O6QoJa__UploadText",
  "UploadedImage": "avatar-uploader-module__O6QoJa__UploadedImage",
  "UploadedWrapper": "avatar-uploader-module__O6QoJa__UploadedWrapper",
});
